//<-------------for local--------------------------->
//  export const APP_BASE_PATH = "http://localhost:3002";
//<------------------------------------------------->
//export const APP_BASE_PATH = "https://api.databin.in";
//<--------------------for production------------------>
   export const APP_BASE_PATH = process.env.REACT_APP_BASE_PATH;
//<------------------------------------------------------->